/* eslint-disable react/sort-comp */
import React from 'react';
import styled from 'styled-components';

import { CSSTransition } from 'react-transition-group';
import PropTypes from 'prop-types'

const LoadingLayer = styled.div`

position: fixed;
background-color: #064C70; // TODO: theme or prop
width: 100vw;
height:100vh;
display: flex;
align-items: center;
z-index: 10;
.loading-container  {
  margin: 0 auto;
  width: 80px;
  text-align: center;
}
   
.sk-child {
  width: 20px;
  height: 20px;
  background-color: white;
  border-radius: 100%;
  display: inline-block;
  -webkit-animation: sk-three-bounce 1.4s ease-in-out 0s infinite both;
          animation: sk-three-bounce 1.4s ease-in-out 0s infinite both; 
}
.sk-bounce1 {
  -webkit-animation-delay: -0.32s;
          animation-delay: -0.32s; 
}
.sk-bounce2 {
  -webkit-animation-delay: -0.16s;
          animation-delay: -0.16s; 
}

@-webkit-keyframes sk-three-bounce {
  0%, 80%, 100% {
    -webkit-transform: scale(0);
            transform: scale(0); }
  40% {
    -webkit-transform: scale(1);
            transform: scale(1); } }

@keyframes sk-three-bounce {
  0%, 80%, 100% {
    -webkit-transform: scale(0);
            transform: scale(0); }
  40% {
    -webkit-transform: scale(1);
            transform: scale(1); } }
`;

const Loading = (props) => {
  return (
    <CSSTransition
      in={props.show}
      timeout={750}
      classNames="intro"
      unmountOnExit
    >
      <LoadingLayer>
        <div className="loading-container">
          <div className="sk-child sk-bounce1" />
          <div className="sk-child sk-bounce2" />
          <div className="sk-child sk-bounce3" />
        </div>
      </LoadingLayer>
    </CSSTransition>
  );
};
Loading.propTypes = {
  show: PropTypes.bool,
};
Loading.defaultProps = {
  show: true,
};

export default Loading;



// WEBPACK FOOTER //
// ./src/components/Loading/Loading.js